import { Link } from "react-router-dom";
import { hotVideos } from "@/mocks/home";

export default function HotVideos() {
  return (
    <section className="py-10 md:py-14 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">
              大家都在看的热门影视内容
            </p>
          </div>
          <Link
            to="/category/recommend"
            className="flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/category/${video.category === "热门推荐" ? "recommend" : video.category === "电视剧" ? "tv-series" : video.category === "综艺" ? "variety" : video.category === "动漫" ? "anime" : "documentary"}`}
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {video.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <div className="flex items-center gap-3 text-white/80 text-xs">
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-400 text-xs"></i> {video.rating}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-xs"></i> {video.views}
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-medium text-foreground-900 group-hover:text-primary-600 text-sm md:text-base mb-2 transition-colors line-clamp-2">
                  {video.title}
                </h3>
                <span className="text-xs text-foreground-400">{video.category}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}